/**
 * Address search boxes are not postal forms: they have their own suggestion
 * list, and a browser or password-manager autofill menu over it either covers
 * the suggestions or fills in the visitor's saved home address. Bitwarden
 * matches on a placeholder or label saying "address", so `autocomplete="off"`
 * alone does not keep it away; each manager reads its own opt-out attribute.
 *
 * The same list is written out as static attributes on
 * `sales-forecast/address-input`, so the prerendered markup carries it too.
 */
export const AUTOFILL_OPT_OUT: Readonly<Record<string, string>> = {
  autocomplete: 'off',
  'data-bwignore': '', // Bitwarden
  'data-1p-ignore': '', // 1Password
  'data-lpignore': 'true', // LastPass
  'data-form-type': 'other', // Dashlane
};

export function optOutOfAutofill(input: HTMLInputElement): void {
  for (const [name, value] of Object.entries(AUTOFILL_OPT_OUT)) {
    input.setAttribute(name, value);
  }
}
